/**
 * API Configuration Constants
 */

export const API_CONFIG = {
	/** Base URL for API requests - falls back to localhost for development */
	BASE_URL: import.meta.env.VITE_API_URL || "http://localhost:3001",

	/** Default timeout for API requests in milliseconds */
	TIMEOUT: 30000, // 30 seconds for mobile connections

	/** Default headers for API requests */
	DEFAULT_HEADERS: {
		"Content-Type": "application/json",
	},
} as const;
